import React from "react";

/** Tiny SVG sparkline — no chart library dependency. */
const SentimentSparkline = ({ series = [], width = 160, height = 36 }) => {
  const points = (series || [])
    .map((p) => p?.avg_sentiment)
    .filter((v) => typeof v === "number" && !Number.isNaN(v));
  if (points.length < 2) {
    return (
      <span style={{ color: "var(--color4)", fontSize: 12 }}>—</span>
    );
  }
  const min = Math.min(...points, -1);
  const max = Math.max(...points, 1);
  const span = max - min || 1;
  const coords = points
    .map((v, i) => {
      const x = (i / (points.length - 1)) * width;
      const y = height - ((v - min) / span) * (height - 4) - 2;
      return `${x},${y}`;
    })
    .join(" ");
  const last = points[points.length - 1];
  const stroke =
    last > 0.15 ? "#389e0d" : last < -0.15 ? "#cf1322" : "#d48806";
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <polyline
        fill="none"
        stroke={stroke}
        strokeWidth="2"
        points={coords}
      />
    </svg>
  );
};

export default SentimentSparkline;
